import { Icon } from '@chakra-ui/react';

export default function SFEnvelopeOutlined(props) {
  return (
    <Icon
      width={5}
      height='15px'
      viewBox='0 0 20 15'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M3.02344 14.1016C1.39844 14.1016 0.570312 13.2891 0.570312 11.6797V3.05469C0.570312 1.44531 1.39062 0.632812 2.78906 0.632812H16.9688C18.5938 0.632812 19.4219 1.44531 19.4219 3.05469V11.6797C19.4219 13.2891 18.6016 14.1016 17.2031 14.1016H3.02344ZM9.24219 7.89844C9.48438 8.11719 9.73438 8.21875 9.99219 8.21875C10.25 8.21875 10.5 8.11719 10.7422 7.89844L17.4219 1.875C17.2969 1.84375 17.1641 1.82812 17.0078 1.82812H2.97656C2.82812 1.82812 2.6875 1.84375 2.5625 1.875L9.24219 7.89844ZM18.2266 3.05469C18.2266 2.9375 18.2188 2.82812 18.1953 2.72656L13.4141 7.03125L18.2188 11.8359C18.2266 11.7891 18.2266 11.7344 18.2266 11.6797V3.05469ZM1.76562 11.6719C1.76562 11.7266 1.76562 11.7812 1.77344 11.8359L6.57812 7.03906L1.78906 2.73438C1.77344 2.82812 1.76562 2.9375 1.76562 3.04688V11.6719ZM2.97656 12.9062H17.0078C17.2188 12.9062 17.4062 12.875 17.5625 12.8125L12.5547 7.80469L11.4219 8.82812C10.9766 9.23438 10.4922 9.42188 9.99219 9.42188C9.49219 9.42188 9.00781 9.23438 8.5625 8.82812L7.42969 7.80469L2.42969 12.8125C2.58594 12.875 2.77344 12.9062 2.97656 12.9062Z' />
    </Icon>
  );
}
